/**
 * What the transit service can read (overmatch/go internal/extract), for
 * every transit upload: the new-transition scan, documents and policies.
 * Legacy .doc/.xls/.ppt aren't readable; 20 MB is transit.MaxUploadBytes.
 */
export const TRANSIT_ACCEPT = '.pdf,.docx,.xlsx,.pptx,.txt,.md,.csv'
export const TRANSIT_ACCEPT_HINT = 'PDF, Word, Excel, PowerPoint, TXT, Markdown, CSV · 20 MB max'

/** The blank vendor questionnaire, served from public/transit/. */
export const TRANSIT_VENDOR_QUESTIONNAIRE = '/transit/Vendor_Readiness_Questionnaire.docx'

/**
 * The documents a transition should have (Bridge "Transition Context",
 * 528:8444; the home page's "Required documents"), each filled by any of its
 * document types. A document goes in the first slot its type is listed in;
 * uploading into a slot sets the slot's first type. Types in no slot, and
 * unsorted documents, are "Other documentation". A slot's `template` is a
 * blank form to download and fill out (in public/transit/), offered while the
 * slot is empty. A `required` slot must have a file before the new-transition
 * modal continues.
 */
export const TRANSIT_CONTEXT_SLOTS: Array<{
  label: string
  types: string[]
  required?: boolean
  template?: { label: string; href: string }
}> = [
  {
    label: 'Vendor questionnaire',
    types: ['vendor_questionnaire'],
    required: true,
    template: { label: 'Download the vendor questionnaire', href: TRANSIT_VENDOR_QUESTIONNAIRE },
  },
  { label: 'Capability statement', types: ['vendor_proposal'] },
  { label: 'Technical specifications', types: ['requirements_document'] },
  { label: 'Test and field reports', types: ['evaluation_report', 'independent_report'] },
  { label: 'Prior contracts or awards', types: ['contract_record'] },
  { label: 'Government briefings', types: ['capability_briefing', 'quad_chart'] },
]
